<template>
  <div>
    <div class="container" >
      <!-- 列表页面 -->
      <div style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >内容管理</el-breadcrumb-item>
          <el-breadcrumb-item >账号管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- <div class="user-distribution">
        <dv-border-box-12 style="">
          <div style="padding: 6px;height: 100%;">
            <div class="header-common">
              <div class="header-common-left">
                <div class="title">账号分布</div>
              </div>
            </div>
            <div class="echart-show" id="mychart"></div>
          </div>
        </dv-border-box-12>
      </div> -->
      <div class="user-info">
            <div class="header-common">
              <div class="header-common-left">
                <div class="title">账号列表信息</div>
              </div>
              <header class="header-common-right">
                <el-button
                  class="right-button-export"
                  @click="exportTable()"
                  type="text"
                  >
                  导出
                </el-button>
                <router-link
                class="right-button-base"
                :to="{path:'/manage/user/user-add'}"
                v-if="showActionAdd==true">
                  新增账号
                </router-link>
              </header>
            </div>
            <el-table
                border
                :cell-style="tableCellStyle"
                :header-cell-style="tableHeaderCellStyle"
                style="width: 100%;"
                :max-height="tableHeight"
                :data="tableData.filter(data => !search || data.groupName.toLowerCase().includes(search.toLowerCase()) || data.username.toLowerCase().includes(search.toLowerCase()) || data.nickname.toLowerCase().includes(search.toLowerCase()) || data.phone.toLowerCase().includes(search.toLowerCase()))"

                >

                <el-table-column
                  type="index"
                  label="序号">
                </el-table-column>
                <el-table-column
                  prop="groupName"
                  label="所属分组">
                </el-table-column>
                <el-table-column
                  prop="username"
                  label="账号名">
                  <template slot-scope="scope">
                    <span v-if="scope.row.equipments.length">
                      <el-popover
                        placement="right"
                        width="400"
                        trigger="click"
                        style="background-color: #208D7F;color: red;"
                        >
                        <el-table :data="gridData"
                          border
                          :cell-style="tableCellStyle"
                          :header-cell-style="tableHeaderCellStyle"
                          style="width: 100%;"
                          height="200"
                        >
                          <el-table-column
                            type="index"
                            label="序号"
                          >
                          </el-table-column>
                          <el-table-column
                            label="所在地区"
                            >
                            <template slot-scope="scope">
                              <span>{{scope.row.provinceName}}/{{scope.row.cityName}}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="hospitalName"
                            label="使用单位">
                          </el-table-column>
                          <el-table-column
                            prop="typeName"
                            label="产品名称">
                          </el-table-column>
                          <el-table-column
                            prop="typeModel"
                            label="规格型号">
                          </el-table-column>
                          <el-table-column
                            prop="udi"
                            label="设备UDI"
                            >
                          </el-table-column>
                          <el-table-column
                            prop="statusText"
                            label="当前状态">
                          </el-table-column>
                        </el-table>
                        <el-button class="hander" slot="reference" @click="showAssociateEquip(scope.row)">{{scope.row.username}}</el-button>
                      </el-popover>
                    </span>
                    <span v-else>{{scope.row.username}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="nickname"
                  label="用户姓名">
                </el-table-column>
                <el-table-column
                  prop="phone"
                  label="用户手机号">
                </el-table-column>
                <el-table-column
                  label="操作">
                  <template slot="header" slot-scope="scope">
                    <el-input
                      id="search"
                      v-model="search"
                      size="mini"
                      placeholder="输入关键字搜索"/>
                  </template>
                  <template slot-scope="scope">
                    <router-link
                      v-if="showActionAdd==true"
                      class="action-button-base"
                      :to="{path:'/manage/user/user-edit',query:{'userId': scope.row.id}}"
                    >
                      <span v-if="scope.row.phone=='--'">去绑定</span>
                      <span v-else >修改绑定</span>
                    </router-link>
                    <el-button
                    v-if="showActionDelete==true"
                      @click.native.prevent="deleteAccount(scope.row,scope.$index)"
                      type="text"
                      size="small"
                      class="action-button">
                      删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  import {dataConversionUtil} from '../../../utils/excel.js'
  import {areaConversionUtil} from '../../../utils/povince_handle.js'
  import {permissionCheckUtil} from '../../../utils/permission.js'

  export default {
    data() {
      return {
        tableHeight:0,
        search:'',
        tableData:[],
        loading:false,

        showActionAdd:false,
        showActionDelete:false,
        gridData:[],
      }
    },
    methods:{
      tableCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);text-align:center;font-size: 14px;font-weight: 400;color: #FEFEFE;'
      },
      tableHeaderCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);background:#021950;text-align:center;font-size: 15px;font-weight: 400;color: #00FFFF;'
      },
      deleteRow(index,rows) {
        row.splice(index,1)
      },
      showAssociateEquip(row){
        this.gridData = row.equipments;
        areaConversionUtil.codeToName(this.gridData);
      },
      getAccountList(){
        this.loading = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/account/list';

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          this.loading = false;
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.accounts){
                // 获取设备数据
                this.tableData = obj.data.accounts;
                this.handleUserData()
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          this.loading = false;
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      handleUserData(){
        var array = this.tableData;
        array.forEach(item=>{
          if(!item.nickname){
            item.nickname = "--"
          }

          if(!item.phone){
            item.phone = "--"
          }
        })
      },
      deleteAccount(row,index){
        this.$confirm('此操作将删除该用户，是否继续？','提示',{
          confirmButtonText:'确定',
          cancelButtonText:'取消',
          type:'warning'
        }).then(() => {
          this.deleteAccountAction(index,row.id);
        }).catch(() => {
          this.$message({
            type:'info',
            message:'取消删除'
          })
        })
      },

      deleteAccountAction(index,val){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/account/delete';
        const data = {"userId":val}

        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.tableData.splice(index,1);
              this.$message({
                type:'success',
                message:'删除成功'
              })
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      exportTable(){
        var tableHeader = [['序号','所属分组','账号名','用户姓名','用户手机号']];
        var dataList = [];
        var documentName = '账号列表'
        this.tableData.forEach((item,index)=>{
          dataList.push([
            index+1,
            item.groupName,
            item.username,
            item.nickname,
            item.phone
          ]);
        });
        
        if(dataList.length > 0){
          dataConversionUtil.dataToExcel(documentName,tableHeader,dataList)
          this.$message.success('导出成功')
        }else{
          this.$message.warning('无数据导出')
        }
        
      },
      judgePermissions(){
          let account1 = permissionCheckUtil.findName("account:create");
          let account2 = permissionCheckUtil.findName("account:delete");

          if(account1==true){
            this.showActionAdd = true;
          }
          if(account2==true){
            this.showActionDelete = true;
          }
      },
      sizeFun(){
        this.$nextTick(() => {
          this.tableHeight = window.innerHeight-220 < 300 ? 300 : window.innerHeight-220;
        })
      }
    },
    mounted() {
      window.addEventListener('resize',this.sizeFun)

      this.sizeFun()
      this.getAccountList();
      this.judgePermissions()
    },
    created() {


    },
    beforeDestroy() {
      window.removeEventListener('resize',this.sizeFun)
    }
  }
</script>


<style lang="scss" scoped>
.container {
  height: 100%;
  margin-top: $header-height;

  .user-distribution{
    height: 320px;

    .echart-show{
      width: 100%;
      height: 85%;
    }
  }

  .user-info{
    border-radius: 12px;

    // position: fixed;
    // top: $header-height+395px;
    // right: 20px;
    // left: 230px;
    // bottom: $main-padding;
    // margin-top: $main-padding;


    .hander{
      // cursor: pointer;
      color: #fff;
      background-color: #104C90;
      border: 0px;
    }
  }

    .header-common{
      width: 100%;
      height: 45px;
      border-radius: 12px 12px 0 0 ;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .header-common-left{
        font-size: 20px;
        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;

        .title{
          font-size: 20px;
          font-weight: bold;
          color: #FEFEFE;
        }
      }

      .header-common-right{

        .right-button{
          width: 89px;
          height: 40px;
          background: #FAFAFA;
          border: 1px solid rgba(0,255,96,0.84);
          border-radius: 20px;
          background-color: #208D7F;
          font-size: 14px;
          font-weight: 400;
          color: #00FFB4;
          margin-right: 20px;
        }

        .right-button-export{
          font-size: 14px;
          font-weight: 400;
          color: #00FFB4;
          margin-right: 20px;
        }

        .right-button-base{
          width: 89px;
          height: 40px;
          border: 1px solid rgba(0,144,255,0.84);
          border-radius: 20px;
          background-color: #20478D;
          font-size: 14px;
          font-weight: 400;
          color: #00DEFF;
          margin-right: 20px;
          display: inline-block;
          line-height: 40px;
          text-align: center;
          text-decoration: none;
        }
      }
    }

  .action-button{
    width: 89px;
    height: 31px;
    background-color: #20478D;
    border: 1px solid rgba(0,144,255,0.84);
    border-radius: 18px;
    font-size: 14px;

    font-weight: 400;
    color: #00DEFF;
  }

  .action-button-base{
    width: 89px;
    height: 31px;
    background-color: #20478D;
    border: 1px solid rgba(0,144,255,0.84);
    border-radius: 18px;
    font-size: 14px;

    font-weight: 400;
    color: #00DEFF;
    display: inline-block;
    line-height: 31px;
    text-align: center;
    text-decoration: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/manage/user/user-list.vue